module.exports = __webpack_public_path__ + "a834f711b1040c1d4123bec63e4f57a9.png";